import 'bootstrap';
import Vue from 'vue';
import './modules/axios';
import 'babel-polyfill';

window.$ = window.jQuery = require('jquery');
window.Vue = Vue;
